import { render, staticRenderFns } from "./relic.vue?vue&type=template&id=e51c17f2"
import script from "./relic.vue?vue&type=script&lang=js"
export * from "./relic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports